/**
 * «УВІЙТИ ЯК КОРИСТУВАЧ» — whom the super admin is looking through.
 *
 * The backend is stateless (Symfony switch_user, api/src/Security/Impersonation.php):
 * the super admin keeps their own token and names the user in an
 * `X-Switch-User` header on EVERY request. This is where that name lives
 * between page loads; requestHeaders.js sends it, /api/me confirms it
 * (`impersonator`), and logging out forgets it.
 *
 * Starting and stopping reload the page, so nothing fetched as one person is
 * left on screen as the other.
 */
const STORAGE_KEY = 'impersonate';

export const IMPERSONATION_HEADER = 'X-Switch-User';

export const getImpersonatedUsername = () => {
    try {
        return window.localStorage.getItem(STORAGE_KEY) || null;
    } catch (e) {
        return null;
    }
};

export const clearImpersonation = () => {
    try {
        window.localStorage.removeItem(STORAGE_KEY);
    } catch (e) {
        /* nothing stored, nothing to forget */
    }
};

export const startImpersonation = username => {
    window.localStorage.setItem(STORAGE_KEY, username);
    window.location.assign('/');
};

export const stopImpersonation = () => {
    clearImpersonation();
    window.location.assign('/');
};
